module.exports = __webpack_public_path__ + "static/media/Michael.b265d84c.png";